<ng-container *ngIf="!!get">
    <div>
        <tt-card class="col-xs-4 sp-5">
            <tt-input ttLabel="prod_name" [(ttModel)]="get.prod_name" (ttModelChange)="onChange('prod_name')"></tt-input>
            <tt-input ttLabel="dimension" [(ttModel)]="get.dimension" (ttModelChange)="onChange('dimension')"></tt-input>
            <tt-search
                ttLabel="materialgrade_name"
                [(ttModel)]="get.materialgrade_name"
                ttMinLength="0"
                [ttData]="materialGrades"
                ttFilterOperation="filter"
                ttDataId="materialgrade_keyno"
                ttDataName="materialgrade_name"
                (ttOnSelected)="onMaterialGradeSelected($event)"
                (ttOnClear)="onMaterialGradeSelected()"
            >
                <ng-container buttons>
                    <tt-form-field-button ttIcon="far fa-bars" ttTooltip="edit_materialgrades" [ttTranslateTooltip]="true" (ttClick)="openMaterialGrades()"></tt-form-field-button>
                </ng-container>
            </tt-search>
            <tt-input-number
                ttLabel="weight_workpiece_kg"
                [(ttModel)]="get.weight_workpiece_kg"
                (ttModelChange)="onWeightChanged()"
                ttFormatNumber
                ttAllowEmpty="false"
                ttTextAlign="right"
                ttDecimals="2"
            ></tt-input-number>
            <tt-input-number
                ttLabel="weight_net_kg"
                [(ttModel)]="get.weight_net_kg"
                (ttModelChange)="onNetWeightChanged()"
                ttFormatNumber
                ttAllowEmpty="false"
                ttTextAlign="right"
                ttDecimals="2"
            ></tt-input-number>
            <tt-search
                *ngIf="get.certificaterequirement_keyno === '0'"
                #certificateSearchInput
                ttLabel="certificaterequirement_name"
                [(ttModel)]="get.certificaterequirement_name"
                (ttModelChange)="onCertificateRequirementChanged($event)"
                ttMinLength="0"
                [ttData]="certificateRequirements"
                ttFilterOperation="filter"
                ttDataId="certificaterequirement_keyno"
                ttDataName="certificaterequirement_name"
                (ttOnSelected)="onCertificateRequirementSelected($event)"
                (ttOnClear)="onCertificateRequirementSelected()"
            >
                <ng-container buttons>
                    <tt-form-field-button ttIcon="far fa-bars" ttTooltip="edit_certificationrequirements" [ttTranslateTooltip]="true" (ttClick)="openCertificateRequirements()"></tt-form-field-button>
                </ng-container>
            </tt-search>
            <tt-input
                *ngIf="get.certificaterequirement_keyno > '0'"
                #certificateTextInput
                ttLabel="certificaterequirement_name"
                [(ttModel)]="get.certificaterequirement_name"
                (ttModelChange)="onCertificateRequirementChanged($event)"
                ttShowClearButton
            >
                <ng-container buttons>
                    <tt-form-field-button ttIcon="far fa-bars" ttTooltip="edit_ultrasonicclasses" [ttTranslateTooltip]="true" (ttClick)="openCertificateRequirements()"></tt-form-field-button>
                </ng-container>
            </tt-input>
            <tt-search
                *ngIf="get.ultrasonicclass_keyno === '0'"
                #ultraSonicSearchInput
                ttLabel="ultrasonicclass_name"
                [(ttModel)]="get.ultrasonicclass_name"
                (ttModelChange)="onUltraSonicClassChanged($event)"
                ttMinLength="0"
                [ttData]="ultraSonicClasses"
                ttFilterOperation="filter"
                ttDataId="ultrasonicclass_keyno"
                ttDataName="ultrasonicclass_name"
                (ttOnSelected)="onUltraSonicClassSelected($event)"
                (ttOnClear)="onUltraSonicClassSelected()"
            >
                <ng-container buttons>
                    <tt-form-field-button ttIcon="far fa-bars" ttTooltip="edit_ultrasonicclasses" [ttTranslateTooltip]="true" (ttClick)="openUltraSonicClasses()"></tt-form-field-button>
                </ng-container>
            </tt-search>
            <tt-input
                *ngIf="get.ultrasonicclass_keyno > '0'"
                #ultraSonicTextInput
                ttLabel="ultrasonicclass_name"
                [(ttModel)]="get.ultrasonicclass_name"
                (ttModelChange)="onUltraSonicClassChanged($event)"
                ttShowClearButton
            >
                <ng-container buttons>
                    <tt-form-field-button ttIcon="far fa-bars" ttTooltip="edit_ultrasonicclasses" [ttTranslateTooltip]="true" (ttClick)="openUltraSonicClasses()"></tt-form-field-button>
                </ng-container>
            </tt-input>
            <tt-search
                ttLabel="prodgrp"
                [(ttModel)]="get.prodgrp_name"
                ttMinLength="0"
                [ttData]="productGroups"
                ttFilterOperation="filter"
                ttDataId="prodgrp_id"
                ttDataName="prodgrp_name"
                (ttOnSelected)="onProductGroupSelected($event)"
                (ttOnClear)="onProductGroupSelected()"
            ></tt-search>
            <tt-input-number
                ttLabel="workpiece_thickness_mm"
                [(ttModel)]="get.workpiece_thickness_mm"
                (ttModelChange)="onWorkpieceThicknessMMChanged()"
                ttFormatNumber
                ttTextAlign="right"
            ></tt-input-number>
        </tt-card>
        <tt-card class="col-xs-4 sp-5">
            <tt-input-number
                ttLabel="ordered_quantity"
                [(ttModel)]="get.ordered_quantity"
                (ttModelChange)="onOrderedQuantityChanged()"
                ttFormatNumber
                ttTextAlign="right"
                ttDecimals="2"
            ></tt-input-number>
            <tt-input-number ttLabel="cost_amount_locval_pr_sku" [(ttModel)]="get.cost_amount_locval_pr_sku" ttFormatNumber ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="markup_pst" [(ttModel)]="get.markup_pst" (ttModelChange)="onChange('markup_pst')" ttFormatNumber ttTextAlign="right" ttDecimals="2"></tt-input-number>
            <tt-input-number
                ttLabel="sales_price_locval_pr_sku"
                [(ttModel)]="get.sales_price_locval_pr_sku"
                (ttModelChange)="onChange('sales_price_locval_pr_sku')"
                ttFormatNumber
                ttTextAlign="right"
                ttDecimals="2"
            ></tt-input-number>
            <tt-input-number ttLabel="amount_locval_total" [(ttModel)]="get.amount_locval_total" ttFormatNumber ttAllowEmpty="false" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number
                ttLabel="sales_price_locval_pr_kg"
                [(ttModel)]="get.sales_price_locval_pr_kg"
                (ttModelChange)="onChange('sales_price_locval_pr_kg')"
                ttFormatNumber
                ttTextAlign="right"
                ttDecimals="2"
                ttReadonly
            ></tt-input-number>
            <tt-input-number
                ttLabel="margin_locval_total"
                [(ttModel)]="get.margin_locval_total"
                (ttModelChange)="onChange('margin_locval_total')"
                ttFormatNumber
                ttTextAlign="right"
                ttDecimals="2"
                ttReadonly
            ></tt-input-number>
        </tt-card>
        <tt-card class="col-xs-4 sp-5">
            <tt-search
                ttLabel="productionrouting"
                [(ttModel)]="get.productionrouting_name"
                ttMinLength="0"
                [ttData]="productionRoutings"
                ttFilterOperation="filter"
                ttDataId="productionrouting_keyno"
                ttDataName="productionroutinglang_name"
                (ttOnSelected)="onProductionRoutingSelected($event)"
                (ttOnClear)="onProductionRoutingSelected()"
            ></tt-search>
            <tt-multi-select
                *ngIf="productionRoutingWorks.length > 0"
                ttLabel="productionroutingwork_options"
                ttLabelView="auto"
                [ttData]="$any(productionRoutingWorks)"
                (ttDataChange)="onProductionRoutingWorkSelectedChange($event)"
                ttDataName="operation_name"
                ttDataId="productionroutingwork_keyno"
            ></tt-multi-select>
            <tt-button *ngIf="get.is_saved === '0'" ttText="calc_copy_from" ttIcon="fas fa-clone" (ttClick)="openCopyFrom()"></tt-button>
            <tt-button *ngIf="get.is_saved === '0'" ttText="reset" (ttClick)="reset()"></tt-button>
            <tt-button-save [ttLoading]="saving" (ttClick)="save()"></tt-button-save>
        </tt-card>
    </div>
</ng-container>

<tt-grid *ngIf="!!grid" class="flex-1" style="min-height: 300px" [(ttOptions)]="grid" (ttRowDataChange)="onRowDataChange($event)" (ttOnRead)="setCostAmountLocval()"></tt-grid>
<!-- {{ get | json }} -->

<!-- {{ get | json }} -->
